import { Action, createReducer, on } from '@ngrx/store'
import { InitializeState, initialInitializeState } from '../state/initial.state'
import {
  fetch_company_setting_preferences_data_success,
  initialize_success,
  update_feedback_ui_status,
  update_password_auto_generated,
  update_user_mobile_number
} from '../action/initialize.action'

export function initializeReducer(state: InitializeState, action: Action) {
  return _initializeReducer(state, action)
}

const _initializeReducer = createReducer(
  initialInitializeState,
  on(initialize_success, (state, data) => {
    return {
      ...state,
      initialized: true,
      taskTypes: data.initializeData.taskTypes as any,
      user: data.initializeData.user,
      uiStatusMapping: data.initializeData.uiStatusMapping,
      feedbackList: data.initializeData.feedbackList,
      newJoineeActivityDetails: data.initializeData.newJoineeActivityDetails,
      screenConfigs: data.initializeData.screenConfigs,
      companyLogoUrl: data.initializeData.companyLogoUrl,
      companyGroupCode: data.initializeData.companyGroupCode,
      authType: data.initializeData.authType,
      companySettings: {
        ...data.initializeData.companySettings,
        modules: data.initializeData.enabledModules ?? data.initializeData.companySettings?.modules ?? [],
        notificationPreferences: data.initializeData.companySettings?.notificationPreferences ?? []
      }
    }
  }),
  on(update_password_auto_generated, (state, data) => {
    return {
      ...state,
      user: { ...state.user, passwordAutoGenerated: data.val }
    }
  }),
  on(fetch_company_setting_preferences_data_success, (state, { companySettingPreferences }) => {
    return {
      ...state,
      companySettings: {
        ...state?.companySettings,
        notificationPreferences: companySettingPreferences?.notificationPreferences,
        modules: companySettingPreferences?.modules
      }
    }
  }),
  on(update_feedback_ui_status, (state, { feedbackId, newStatus }) => {
    const updatedFeedbackList = state?.feedbackList?.map((feedback) => {
      if (feedback.id === feedbackId) {
        return { ...feedback, uiStatus: newStatus }
      }
      return feedback
    })
    return { ...state, feedbackList: updatedFeedbackList }
  }),
  on(update_user_mobile_number, (state, { mobileNumber }) => {
    return {
      ...state,
      user: { ...state.user, mobileNumber: mobileNumber }
    }
  })
)
